/**
 * The entries the sidebar drew for this person, published so the page guard and
 * the links (useCanOpen) ask the sidebar's rule rather than a copy of it. Null
 * while the company or the person is still loading. A set of addresses stands
 * for the fixed menu's entries at those addresses (tests use it).
 */
import type { NavMenu } from '../layout/Sidebar';

export type DrawnNav = NavMenu | ReadonlySet<string>;

let drawn: DrawnNav | null = null;
const listeners = new Set<() => void>();

export function publishDrawnNav(next: DrawnNav | null): void {
  drawn = next;
  for (const l of listeners) l();
}

export function readDrawnNav(): DrawnNav | null {
  return drawn;
}

export function subscribeDrawnNav(l: () => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}
